<!-- @format -->

<h3 class="titleHeading">Delegations</h3>

<div class="delegationsContainer">
	<div class="delegation-table-container">
		<div class="delegation-table">
			<!-- table header row -->
			<div class="delegation-row-header">
				<div class="row-data">
					<div
						class="role"
						*ngIf="isTimekeeper"
						[class.sortActive]="getIsColumnSorted('roleSort')"
						(click)="setFormSortedColumn('roleSort')">
						Delegated Role <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('roleSort')"></span>
					</div>
					<div
						class="fromUser"
						[class.timeKeeperView]="isTimekeeper"
						[class.sortActive]="getIsColumnSorted('fromUserSort')"
						(click)="setFormSortedColumn('fromUserSort')">
						Delegate From <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('fromUserSort')"></span>
					</div>
					<div
						class="toUser"
						[class.timeKeeperView]="isTimekeeper"
						[class.sortActive]="getIsColumnSorted('toUserSort')"
						(click)="setFormSortedColumn('toUserSort')">
						Delegate To <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('toUserSort')"></span>
					</div>
					<div class="fromDate" [class.sortActive]="getIsColumnSorted('startDateSort')" (click)="setFormSortedColumn('startDateSort')">
						Start Date <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('startDateSort')"></span>
					</div>
					<div class="toDate" [class.sortActive]="getIsColumnSorted('endDateSort')" (click)="setFormSortedColumn('endDateSort')">
						End Date <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('endDateSort')"></span>
					</div>
					<div class="status" [class.sortActive]="getIsColumnSorted('statusSort')" (click)="setFormSortedColumn('statusSort')">
						Status <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('statusSort')"></span>
					</div>
				</div>

				<div class="trashIcon"></div>
			</div>

			<ng-container *ngIf="delegations.length === 0">
				<div class="noResults">No delegations scheduled</div>
			</ng-container>

			<!-- table data rows -->
			<div class="delegation-row-data" *ngFor="let delegation of delegations">
				<div class="row-data" (click)="openEditSidePanel(delegation, sidePanel)">
					<div class="role" *ngIf="isTimekeeper">{{ getDelegationRole(delegation) }}</div>
					<div class="fromUser" [class.timeKeeperView]="isTimekeeper">{{ getUserFromUserId(delegation.fromUserId!) }}</div>
					<div class="toUser" [class.timeKeeperView]="isTimekeeper">{{ getUserFromUserId(delegation.toUserId) }}</div>
					<div class="fromDate">{{ getDateString(delegation.from) }}</div>
					<div class="toDate">{{ getDateString(delegation.to) }}</div>
					<div class="status">{{ delegation.active ? "Active" : "Inactive" }}</div>
				</div>

				<!-- If you are delegated, then use the empty space to trigger the edit modal prompt that you cant edit the entry -->
				<div
					class="trashIcon"
					*ngIf="getIsUserAssignee(delegation) && !getIsDelegationCreator(delegation)"
					(click)="openEditSidePanel(delegation, sidePanel)"></div>
				<div class="trashIcon" *ngIf="!getIsUserAssignee(delegation) || getIsDelegationCreator(delegation)">
					<!-- <button (click)="deleteDelegation(delegation)" class="button-removestyles" [class.disabled]="getIsUserAssignee(delegation)"> -->
					<button (click)="deleteDelegation(delegation)" class="button-removestyles">
						<i class="fa-light fa-trash fa-2xl"></i>
					</button>
				</div>
			</div>
		</div>
	</div>

	<div class="add-delegation add-row-btn">
		<button (click)="openSidePanel(sidePanel)">
			<div class="add-row-circle"><span>+</span></div>
			<span>Add a Delegation</span>
		</button>
	</div>
</div>

<ng-template #sidePanel let-offcanvas>
	<div class="delegation-side-panel">
		<div class="offcanvas-header">
			<h4 class="offcanvas-title add-delegation-header" id="offcanvas-basic-title">
				<h3 *ngIf="!isEdit"><b>Add a delegation</b></h3>
				<h3 *ngIf="isEdit"><b>Edit delegation</b></h3>
			</h4>

			<button type="button" class="btn-close" aria-label="Close" (click)="closeSidePanel()"></button>
		</div>

		<div class="offcanvas-body">
			<form [formGroup]="delegationForm" (ngSubmit)="submitDelegationForm()" #formDir="ngForm" spellcheck="false">
				<div class="modal-body-non-center">
					<ng-container *ngIf="isTimekeeper">
						<p [class.error]="!formStateValidity.role && formTouchedState.role">Delegated Role</p>
						<ng-select
							formControlName="role"
							placeholder="Select one"
							[items]="roleList"
							bindValue="id"
							bindLabel="roleName"
							(change)="doErrorChecking('role', true)">
						</ng-select>

						<ng-container *ngIf="showFromControl">
							<p [class.error]="!formStateValidity.fromUser && formTouchedState.fromUser">Delegate From</p>
							<ng-select
								formControlName="fromUser"
								placeholder="Select one"
								[items]="selectableUsersListFrom"
								bindValue="id"
								bindLabel="fullName"
								(change)="doErrorChecking('fromUser', true)">
							</ng-select>
						</ng-container>
					</ng-container>

					<p [class.error]="!formStateValidity.toUser && formTouchedState.toUser">Delegate To</p>
					<ng-select
						formControlName="toUser"
						placeholder="Select one"
						[items]="selectableUsersListTo"
						bindValue="id"
						bindLabel="fullName"
						(change)="doErrorChecking('toUser', true)">
					</ng-select>

					<p [class.error]="!formStateValidity.from && formTouchedState.from">Start Date</p>
					<div class="input-group">
						<div class="control-wrapper">
							<input
								class="form-control invisible p-0"
								placeholder="yyyy-mm-dd"
								name="dp1"
								ngbDatepicker
								#d1="ngbDatepicker"
								[firstDayOfWeek]="6"
								[dayTemplate]="startDaysList"
								[weekdays]="1"
								[minDate]="minDateFrom"
								[placement]="'bottom-start'"
								[navigation]="'arrows'"
								(dateSelect)="onDateSelect($event, 'from')" />

							<input
								class="form-control"
								type="text"
								formControlName="from"
								(click)="d1.toggle();"
								placeholder="Select start date"
								(blur)="doErrorChecking('from')" />

							<ng-template #startDaysList let-date let-currentMonth="currentMonth">
								<span [class.shade]="shouldDarkenEntryBG(date)" [class.outsideMonth]="date.month !== currentMonth">
									<span [class.selectedDate]="isSelectedDate(date, 'from')">
										{{ date.day }}
									</span>
								</span>
							</ng-template>
						</div>

						<button class="btn btn-outline-secondary" (click)="d1.toggle();" type="button">
							<i class="fa-regular fa-calendar"></i>
						</button>
					</div>

					<p [class.error]="!formStateValidity.to && formTouchedState.to">End Date</p>
					<div class="input-group">
						<div class="control-wrapper">
							<input
								class="form-control invisible p-0"
								placeholder="yyyy-mm-dd"
								name="dp2"
								ngbDatepicker
								#d2="ngbDatepicker"
								[firstDayOfWeek]="6"
								[dayTemplate]="endDateDays"
								[weekdays]="1"
								[minDate]="minDateTo"
								[placement]="'bottom-start'"
								[navigation]="'arrows'"
								(dateSelect)="onDateSelect($event, 'to')" />

							<input
								class="form-control"
								type="text"
								formControlName="to"
								(click)="d2.toggle();"
								placeholder="Select end date"
								(blur)="doErrorChecking('to')" />

							<ng-template #endDateDays let-date let-currentMonth="currentMonth">
								<span [class.shade]="shouldDarkenEntryBG(date)" [class.outsideMonth]="date.month !== currentMonth">
									<span [class.selectedDate]="isSelectedDate(date, 'to')">
										{{ date.day }}
									</span>
								</span>
							</ng-template>
						</div>

						<button class="btn btn-outline-secondary" (click)="d2.toggle();" type="button">
							<i class="fa-regular fa-calendar"></i>
						</button>
					</div>

					<div class="buttonContainer">
						<button type="button" class="btn btn-submission-cancel" (click)="closeSidePanel()">Cancel</button>
						<button type="submit" class="btn btn-submission-submit" [class.disabled]="!allFormsValid" [disabled]="!allFormsValid">
							{{isEdit ? "Update" : "Confirm"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</ng-template>

<ng-template #deleteModal let-modal>
	<div class="modal-delete-body">
		<h3><b> Delete delegation? </b></h3>
		<p class="deleteConfirmation">
			Please confirm if you wish to delete the delegation assignment for {{ getUserFromUserId(delegationForm.controls.toUser.value) }}.
		</p>

		<div class="buttonContainer">
			<button type="button" class="btn btn-submission-cancel" (click)="closeDeleteModal(false)">Cancel</button>
			<button type="submit" class="btn btn-submission-submit" (click)="closeDeleteModal(true)">Confirm</button>
		</div>
	</div>
</ng-template>
